/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MobileDeviceRenewRequestRequest
 */
export interface MobileDeviceRenewRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceRenewRequestRequest
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceRenewRequestRequest
     */
    tempToken?: string;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceRenewRequestRequest
     */
    codeVerifier?: string;
}

/**
 * Check if a given object implements the MobileDeviceRenewRequestRequest interface.
 */
export function instanceOfMobileDeviceRenewRequestRequest(value: object): value is MobileDeviceRenewRequestRequest {
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    return true;
}

export function MobileDeviceRenewRequestRequestFromJSON(json: any): MobileDeviceRenewRequestRequest {
    return MobileDeviceRenewRequestRequestFromJSONTyped(json, false);
}

export function MobileDeviceRenewRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobileDeviceRenewRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['device_id'],
        'tempToken': json['temp_token'] == null ? undefined : json['temp_token'],
        'codeVerifier': json['code_verifier'] == null ? undefined : json['code_verifier'],
    };
}

export function MobileDeviceRenewRequestRequestToJSON(json: any): MobileDeviceRenewRequestRequest {
    return MobileDeviceRenewRequestRequestToJSONTyped(json, false);
}

export function MobileDeviceRenewRequestRequestToJSONTyped(value?: MobileDeviceRenewRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_id': value['deviceId'],
        'temp_token': value['tempToken'],
        'code_verifier': value['codeVerifier'],
    };
}

